import React from "react";

// Shimmer animation CSS
const shimmerStyles = `
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }

  .shimmer {
    animation: shimmer 2s infinite;
    background: linear-gradient(
      to right,
      #f0f0f0 0%,
      #e0e0e0 20%,
      #f0f0f0 40%,
      #f0f0f0 100%
    );
    background-size: 1000px 100%;
  }
`;

// Nutrition Stats Shimmer
export const NutritionStatsShimmer: React.FC = () => {
  return (
    <>
      <style>{shimmerStyles}</style>
      <div className="mx-6">
        <div className="bg-white px-4 py-4 border-[0.5px] border-[#F3F4F6] rounded-md h-[52px] shimmer"></div>
      </div>
    </>
  );
};

// Breakfast/Meal Card Shimmer (col-span-2)
export const BreakfastCardShimmer: React.FC = () => {
  return (
    <div className="bg-white rounded-md shadow-sm p-4 h-[280px] shimmer col-span-2"></div>
  );
};

// Water Intake Card Shimmer
export const WaterIntakeCardShimmer: React.FC = () => {
  return (
    <div className="bg-white rounded-md shadow-sm p-4 h-[280px] shimmer"></div>
  );
};

// Regular Card Shimmer (Sleep, Gut, Exercise, Supplements, Medicine, Vitals)
export const RegularCardShimmer: React.FC = () => {
  return (
    <div className="bg-white rounded-md shadow-sm p-4 h-[180px] shimmer"></div>
  );
};

// Complete Loading Layout
export const AllLogsLoadingSkeleton: React.FC = () => {
  return (
    <>
      <style>{shimmerStyles}</style>
      <div className="allLogs-fadeIn">
        {/* Nutrition Stats Shimmer */}
        <NutritionStatsShimmer />

        {/* Main Content */}
        <div className="px-6 py-6 space-y-6">
          {/* Row 1: Breakfast + Water */}
          <div className="grid grid-cols-3 gap-6">
            <BreakfastCardShimmer />
            <WaterIntakeCardShimmer />
          </div>

          {/* Row 2: Sleep, Gut, Exercise */}
          <div className="grid grid-cols-3 gap-6">
            <RegularCardShimmer />
            <RegularCardShimmer />
            <RegularCardShimmer />
          </div>

          {/* Row 3: Supplements, Medicine, Vitals */}
          <div className="grid grid-cols-3 gap-6">
            <RegularCardShimmer />
            <RegularCardShimmer />
            <RegularCardShimmer />
          </div>
        </div>
      </div>
    </>
  );
};